import React from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import CardBoxDefault from "../../Components/Layout/CardBoxDefault";
import CardAddress from "../../Components/Layout/Profile/CardAddress";

const ProfileAddresses = () => {
    const { currentStore } = useStoreContext();
    document.title = 'Endereços';

    const addresses = [
        {type: 'Trabalho', address: 'Avenida das Américas, 8600, Recreio dos Bandeirantes, Rio de Janeiro - RJ - CEP: 22790-702'},
        {type: 'Casa', address: 'Estrada dos Bandeirantes, 24331, Vargem Grande, Rio de Janeiro - RJ - CEP: 22785-091'},
        {type: 'Outro', address: 'Av. Rio Branco, 156218/220SSL, Centro, Rio De Janeiro - RJ - CEP: 20040-003'},
    ]
    return (
        <DefaultLayout showHeader={currentStore}>
            <DefaultLayoutProfile>
                <div className="flex flex-col gap-4 p-2">
                    <h4 className='font-semibold'>Endereços</h4>

                    <section className="text-sm">
                        <div className="grid h-full gap-4 md:grid-cols-2 md:grid-cols-3">
                            {addresses.map((address: any, index: number) => (
                                <CardBoxDefault key={index}>
                                    <CardAddress onClick={() => {}} address={address} />
                                </CardBoxDefault>
                            ))}
                        </div>
                    </section>
                </div>
            </DefaultLayoutProfile>
        </DefaultLayout>
    );
};

export default ProfileAddresses;